import { KeyboardEvent } from 'react';
import { Editor } from 'slate';
import { toggleMark } from '../transformers';
import { MarkType } from '../types';

// Ctrl + Key toggles the following marks
const hotkeys: Record<string, MarkType> = {
	b: 'bold',
	i: 'italic',
	u: 'underline',
	s: 'strikethrough',
};

export const onHotKey = (
	event: KeyboardEvent<HTMLDivElement>,
	editor: Editor
) => {
	if (!event.ctrlKey) return;
	Object.entries(hotkeys).forEach(([key, mark]) => {
		if (key !== event.key) return;
		event.preventDefault();
		toggleMark(editor, mark);
	});
};
